<template>
  <modal
    :title="`Import ${platform.name} Posts`"
    size="md"
    :body-style="{padding: 0}"
    ref="modal"
  >
    <create-post-import
      v-if="platform.auth === null"
      :platform="platform"
      :get-account-id="accountIdProvider"
      @created="hide()"
    />
    <connect-account v-else :platform="platform">
      <reconnect-btn
        :account="account"
        color="primary"
        icon-right="fa fa-arrow-right"
        label="Get Started"
        rounded
        @reconnected="hide()"
      />
    </connect-account>
    <request-support
      :platform="platform.name"
      :get-account-id="accountIdProvider"
    />
  </modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ModalMixin } from '@/mixins';
import Modal from '@/components/modal/Modal.vue';
import { Platform, Account } from '@/social/types';
import ReconnectBtn from '@/social/account/action/reconnect/ReconnectBtn.vue';
import CreatePostImport from '../file/CreatePostImport.vue';
import ConnectAccount from '../ConnectAccount.vue';
import RequestSupport from '../support/RequestSupport.vue';

export default defineComponent({
  mixins: [ModalMixin],
  components: {
    ReconnectBtn,
    RequestSupport,
    Modal,
    CreatePostImport,
    ConnectAccount,
  },
  props: {
    account: {
      type: Object as () => Account,
      required: true,
    },
  },
  computed: {
    platform(): Platform {
      return this.account.socialSite;
    },
  },
  methods: {
    async accountIdProvider(): Promise<number> {
      return this.account.id;
    },
  },
});
</script>
